<template>
  <div id="app">
    <router-view/>
    <sider-item class="sider"></sider-item>
    <audio-control ref="audio"></audio-control>
  </div>
</template>

<script>
  import {mapMutations, mapGetters} from "vuex";

  export default {
    name: 'App',
    computed: {
      ...mapGetters(['currTab', 'currGrade', 'userInfo']),
    },
    data() {
      return {
        gradeLock: false,
      }
    },
    watch: {
      currTab(val) {
        val && this.GetPagesCode();
      },
      currGrade(val) {
        this.GetPagesCode();
      },
      userInfo: {
        immediate: true,
        handler(user) {
          !this.gradeLock && user.uid && !user.nianji_id && (this.gradeLock = true) && this.SelectGrade({
            select: sel => {
              this.gradeLock = false;
              this.setCurrGrade(sel);
            },
          });
        }
      },
    },
    created() {
      this.currTab && this.GetPagesCode();
      this.GetWxInfo().catch(this.$err);
      if (this.userInfo.uid) {
        this.GetUserInfoApi(this.userInfo.uid).catch(console.log);
      }
    },
    mounted() {
      this.http.getKfInfo().then(res => {
        this.$store.commit('setKfInfo', res.reduce((r, c) => ({...r, [c.name]: c.value}), {}));
      }).catch(console.log);
    },
    methods: {
      ...mapMutations(['setCurrGrade']),
    },
  }
</script>

<style lang="less" scoped>
  .sider {
    z-index: 100;
    position: fixed;
    top: 50%;
    right: 16px;
    transform: translateY(-50%);
  }
</style>